define('components/util/reload-fragments',[
    'components/decorator',
    'components/util/tool-menu',
    'jquery'
],function(
    decorator,
    toolMenu,
    jQuery
){

    /**
     * Reloads HTML fragments based on data-reload-type.
     * It will load a url ( usually the same page ) and pick fragments from the new page and replaces
     * the fragments on the old page matching data-reload-id's.
     *
     * Step by step:
     * - page contains 3 fragments with data-reload-type "foo"
     * - each of the 3 fragments has a unique data-reload-id.
     * - new page is loaded in memory and all the fragments of data-reload-type "foo" are filtered out into an array.
     * - each fragment is replaced by a new fragment with the same data-reload-id.
     * - A fragment that does not have a new fragment with matching data-reload-id remains unchanged.
     */

    var activeXhr;

    function emptyCallback(){}

    var cache = {};

    /**
     *
     * @param {string} type
     * @param {URL} [url]
     * @param {function} [callback]
     */
    function reload( type, url, postCallback, useCache, preCallback ){
        cancel();

        var sections = getSections(type);

        //the opacity setting will not prevent clicks
        //so also add a transparent mask to prevent the clicks
        sections.each(function(){
          var $this = $(this);
          $this.css({opacity:0.4});
          var height = $this.outerHeight(true);
          var width = $this.outerWidth(true);
          var mask = document.createElement('div');
          $mask = $(mask);
          $mask.addClass("loadmask").width(width).height(height);
          $mask.prependTo($this);
        });
        //sections.css({opacity:0.4});
        if ( sections.length === 0 ) {
            return;
        }

        if ( cache[ url ] ) {
            if(url && postCallback) {
                // History change is not related directy to postCallback but as a backward
                // compatibility issue we will change history only if postCallback is present
                History.pushState({}, document.title, url);
            }

            if(typeof preCallback === "function") {
                preCallback();
            }
            
            replaceContent(cache[ url ], sections);
            return cleanUp( postCallback );
        }

        activeXhr = jQuery.get(url||location.href).done(function(page){
            if ( useCache ) {
                cachePage(url,page);
            }
            if(url && postCallback) {
                // History change is not related directy to postCallback but as a backward
                // compatibility issue we will change history only if postCallback is present
                History.pushState({}, document.title, url);
            }
            if(typeof preCallback === "function") {
                preCallback();
            }
            replaceContent(page, sections);
        }).always(function(){
            cleanUp( postCallback );
        });
    }

    function cleanUp( callback ){
        if ( typeof callback == 'function' ) {
            callback();
        }
        activeXhr = null;
    }

    function getSections(type, ids){
        return jQuery('[data-reload-id]').filter(createFilter(type, ids));
    }

    function createFilter(type, ids){
        return function(){
            var element = this.getAttribute(ids ? 'data-reload-id' : 'data-reload-type').split(' ');
            var filter = false;
            if (ids) {
              for (var i = 0; i < ids.length; i++) {
                if (element.indexOf(ids[i]) > -1) {
                  filter = true;
                }
              }
            } else {
              if (element.indexOf(type) > -1) {
                filter = true;
              }
            }

            return filter;
        };
    }

    function replaceContent( page, sections, stopRefresh ){

        page = jQuery(page).wrap("<div/>").parent();

        sections.each(function () {
            var id = this.getAttribute('data-reload-id');
            var content = page.find('[data-reload-id=' + id + ']').html();
            if (content) {
                this.innerHTML = content;
            }
        });
        sections.animate({opacity:1},300);
        toolMenu.hide();

        if (!stopRefresh) {
          decorator.run();
        }
    }

    function clearCache() {
        cache = {};
    }

    function cachePage( url, page ){
        cache[ url ] = page;
    }

    function isCached( url ){
        return !!cache[ url ];
    }

    function cancel() {
        if ( activeXhr ) {
            activeXhr.abort();
        }
    }

    reload.replaceContent = replaceContent;
    reload.getSections = getSections;
    reload.clearCache = clearCache;
    reload.cachePage = cachePage;
    reload.isCached = isCached;
    reload.cancel = cancel;

    return reload;

});

